import { StyledContainer } from './Container.styled';

export default function Container({ children }) {
  return <StyledContainer>{children}</StyledContainer>;
}
